import { MasterUPCData } from '../types';

export function collectMasterLabelUpcCropImageUrls(
  upc: MasterUPCData,
  priorityCropIds?: Iterable<string>
): string[] {
  const crops = [
    ...upc.designs.flatMap((design) => design.crops),
    ...(upc.pendingCrops ?? []),
    ...upc.unassignedCrops,
    ...upc.cartonCrops,
    ...(upc.inactiveCrops ?? []),
  ];
  const urls: string[] = [];
  const seenUrls = new Set<string>();

  const addCropUrl = (crop: { imageUrl?: string }) => {
    if (!crop.imageUrl || seenUrls.has(crop.imageUrl)) return;
    seenUrls.add(crop.imageUrl);
    urls.push(crop.imageUrl);
  };

  const priorityIds = priorityCropIds ? [...priorityCropIds].filter(Boolean) : [];
  if (priorityIds.length > 0) {
    const cropsById = new Map(crops.map((crop) => [crop.id, crop]));
    priorityIds.forEach((cropId) => {
      const crop = cropsById.get(cropId);
      if (crop) addCropUrl(crop);
    });
  }

  crops.forEach(addCropUrl);
  return urls;
}

export function collectMasterLabelCropImageUrls(upcs: MasterUPCData[]): string[] {
  return [...new Set(upcs.flatMap((upc) => collectMasterLabelUpcCropImageUrls(upc)))];
}
